import React, { useEffect, useRef, useState } from 'react';
import { ColDef, GridOptions } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useAgGridCommon } from 'common/table/agGrid/AgGridCommon';
import { common, mergeGridOpts } from 'utils/agGrid/options';
import { useAppSelector } from 'hooks/useAppSelector';
import { createLoadingSelector } from 'erisxkit/client';
import { LINKED_MEMBER_ASSET_ACCOUNTS } from 'reducers/linkedMemberAssetAccountsReducer';

export interface BankAccount {
  accountNumber: string;
  assetType: string;
  bankName: string;
  createdAt: string;
  hashId: string;
  id: string;
  isPlaidAccount: boolean;
  isSenAccount: boolean;
  isSignetAccount: boolean;
  label: string;
  memberId: string;
  routingNumber: string;
  state: string;
  type: string;
  usableAt: string;
}

interface BankAccountGridProps {
  data: BankAccount[];
  colDefs: ColDef[];
}

const gridOpts = mergeGridOpts(common, {
  defaultColDef: {
    floatingFilter: false,
  },
});

export const gridName = 'bank-account';

const BankAccountGrid: React.FC<BankAccountGridProps> = ({ data, colDefs }) => {
  const gridRef = useRef<AgGridReact>(null);
  const [rowData, setRowData] = useState<BankAccount[]>([]);
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);

  useEffect(() => {
    setColumnDefs(colDefs);
  }, [colDefs]);

  const { gridVisible, initialGridSettings, onStateUpdated } = useAgGridCommon({
    gridName,
  });
  const loading = useAppSelector((state) =>
    createLoadingSelector([LINKED_MEMBER_ASSET_ACCOUNTS])(state),
  );
  useEffect(() => {
    setRowData(data);
    if (!initialGridSettings?.columnSizing) {
      gridRef.current?.api?.sizeColumnsToFit();
    }
  }, [data]);

  return (
    <div className="ag-theme-quartz">
      {gridVisible && (
        <AgGridReact
          loading={loading}
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          gridOptions={gridOpts}
          onStateUpdated={onStateUpdated}
          initialState={initialGridSettings}
        />
      )}
    </div>
  );
};

export default BankAccountGrid;
